module.exports = __webpack_public_path__ + "static/004-2196517da33d48dd35f4ca7960ca87d5.jpeg";